import React, {
    useState,
    FormEvent
} from 'react';
import { LANGUAGE, GetLanguage, GetStr } from "../language/Language";
import { Http } from '@capacitor-community/http';
import { Plugins, Capacitor } from '@capacitor/core';

// for crypto
const CryptoJS = require("crypto-js");

// server address
const serverAddress = "https://nwallet.me/n/";

const serverCDNAddress = "https://nwallet.site/";

interface WebReply {
    success : string;
    message : string;
}

var uiElements : { [index: string]: number; } = {
};

export const UIElement = (type : string) : string => {
    let visible = false;
    if (uiElements.hasOwnProperty(type))
    {
        if (uiElements[type] == 1)
            visible = true;
    }

    // for testing
    //DEL return "";

    if (!visible)
        return "ion-hide";
    // else 
    return "";
};

// register the general service
export const RegisterAppServices = () => {
    // install back button
    if (Capacitor.isNative) {
        Plugins.App.addListener("backButton", () => {
            if (window.location.pathname == '/main')
            {
                // make sure no modal is opened
                const modal = document.getElementById('modal');
                if (modal == null)
                    Plugins.App.exitApp();
            }
        });
    }
}

export const handleRouteError = (router : any, data : any) => {
    if (data != null)
    {
        if (data.hasOwnProperty('path'))
        {
            let err_path = data.path;
            
            if (err_path == "update")
                router.push("/update", "back", "pop");

            if (err_path == "mantain")
                router.push("/mantain", "back", "pop");

            if (err_path == "login")
                router.push("/login", "back", "pop");
        }
    }
};

// for communiting with server
export default class NServer
{
    private VERSION : string = "1";

    private ENC_KEY : string = "987654abcdef3210ab76543210cdef98";
    private IV : string = "abcdef9876543210abcdef9876543210";
    
    private CDN_ENC_KEY : string = "de7654abc98f32108976543ee0cdef10";
    private CDN_IV : string = "12cdef9876543ab012cdef9876543ab0";

    public error : boolean = false;
    public success : boolean = false;
    public message : string = "";
    public data : any;

    // read UI data from the stream
    readUIData(res : any) {
        if (res.hasOwnProperty('ui'))
        {
            // update ui elements
            uiElements = res.ui;
        }
    }

    // encrypt with default key
    encrypt(state : any) : string {
        var d = JSON.stringify(state);

        var key = CryptoJS.enc.Hex.parse(this.ENC_KEY);
        var iv = CryptoJS.enc.Hex.parse(this.IV);
        var cipherData = CryptoJS.AES.encrypt(d, key, { iv: iv });

        return cipherData;
    }

	// when form submit
    async sendForm(api : string, state : any) {
        this.success = false;
        this.message = "error";
        this.error = false;

        var d = JSON.stringify(state);

        var key = CryptoJS.enc.Hex.parse(this.ENC_KEY);
        var iv = CryptoJS.enc.Hex.parse(this.IV);
        var cipherData = CryptoJS.AES.encrypt(d, key, { iv: iv });
        
        return fetch(serverAddress + api + '.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Version': this.VERSION,
                'App': 'social',
                'Language': GetLanguage()
            },
            body: cipherData
        })
        .then(
            res => res.text()
        )
        .then(
            (res) => {
                // console.log("Reply: " + res);

                let key = CryptoJS.enc.Hex.parse(this.ENC_KEY);
                let iv = CryptoJS.enc.Hex.parse(this.IV);
                let reply = CryptoJS.AES.decrypt(res, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
                
                let obj = JSON.parse(reply);
                
                this.error = false;
                if (obj.success == "yes")
                    this.success = true;
                this.message = obj.message; 
                this.data = obj.data;

                // read extra data from network
                this.readUIData(obj);
            }
        ).catch(
            err => {
                this.message = GetStr(LANGUAGE.TXT_SERVER_ERROR);
                console.log("Server-> " + err);
            }
        );
    }

    // retrieve a list of item
    async getList(api : string, state : any) {
        this.success = false;
        this.message = "error";
        this.error = false;

        var param = '';
        if (state != null)
        {
            var d = JSON.stringify(state);

            var key = CryptoJS.enc.Hex.parse(this.ENC_KEY);
            var iv = CryptoJS.enc.Hex.parse(this.IV);
            var cipherData = CryptoJS.AES.encrypt(d, key, { iv: iv });

            param = '?d=' + encodeURIComponent(cipherData);

            // console.log("URI-> " + serverAddress + api + '.php' + param);
        }

        return fetch(serverAddress + api + '.php' + param, {
            method: 'GET',
            headers: {
                'Version': this.VERSION,
                'App': 'social',
                'Language': GetLanguage()
            },
        })
        .then(
            res => res.text()
        )
        .then(
            (res) => {

                // console.log("Reply: " + res);
                
                let key = CryptoJS.enc.Hex.parse(this.ENC_KEY);
                let iv = CryptoJS.enc.Hex.parse(this.IV);
                let reply = CryptoJS.AES.decrypt(res, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
                
                // console.log("Reply: " + reply);
                
                let obj = JSON.parse(reply);
                
                this.error = false;
                if (obj.success == "yes")
                    this.success = true;
                this.message = obj.message;
                this.data = obj.data;

                // read extra data from network
                this.readUIData(obj);
            }
        ).catch(
            err => {
                this.message = GetStr(LANGUAGE.TXT_SERVER_ERROR);
                // console.log("Server-> " + err);
            }
        );
    }

    // upload image to server
    async uploadImage(uri : string, state : any) {
        
        this.success = false;
        this.message = "error";
        this.error = false;

        const formData = new FormData();
        var d = JSON.stringify(state);

        var key = CryptoJS.enc.Hex.parse(this.CDN_ENC_KEY);
        var iv = CryptoJS.enc.Hex.parse(this.CDN_IV);
        var cipherData = CryptoJS.AES.encrypt(d, key, { iv: iv });

        formData.set('d', cipherData);

        Http.addListener("progress", (e) => {
            console.log("Progress-> ", e);
        });

        await fetch(uri).then(
            res => res.blob()
        ).then(
            (res) => {
                formData.append('file', res, uri);
            }
        );
        
        return fetch(serverCDNAddress + 'put.php', {
            method: 'POST',
            body: formData
        })
        .then(
            // res => res.text()
            res => res.json()
        )
        .then(
            (res) => {
                this.error = false;
                if (res.success == "yes")
                    this.success = true;
                this.message = res.message;
                this.data = res.data;
            }
        ).catch(
            err => {
                this.message = GetStr(LANGUAGE.TXT_SERVER_ERROR);
                console.log("Server-> " + err);
            }
        );
    }
}